import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OperatorFunction, pipe } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../../app.config';
import { FocusSelectorFocusForPerformer } from '../../coaching-base/general';
import { catchErrorLogRet } from '../../common/rest.operators';

@Injectable()
export class FocusSelectorService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    retrieveFocusesForPerformer<T>(
        project: () => {
            userId: number;
        },
    ): OperatorFunction<T, FocusSelectorFocusForPerformer> {
        return pipe(
            switchMap(() => {
                const args = project();
                let params = new HttpParams();

                if (args.userId != null) {
                    params = params.set('userId', args.userId.toString());
                }

                return this._http.get(
                    `${this._appConfig.API_ENDPOINTS.COACHING}/focus-selector/focus-for-performer`,
                    { params },
                );
            }),
            catchErrorLogRet({}),
        );
    }
}
